import { render, staticRenderFns } from "./lookSysStudentIn.vue?vue&type=template&id=1fff8949&scoped=true&"
import script from "./lookSysStudentIn.vue?vue&type=script&lang=js&"
export * from "./lookSysStudentIn.vue?vue&type=script&lang=js&"
import style0 from "./lookSysStudentIn.vue?vue&type=style&index=0&id=1fff8949&scoped=true&lang=scss&"
import style1 from "./lookSysStudentIn.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff8949",
  null
  
)

export default component.exports